import { Button, InternationalMap } from "@/components";
import Styles from "./Partners.module.css";
import { useState, useEffect } from "react";
import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.PartnersSlice} PartnersSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PartnersSlice>} PartnersProps
 * @param {PartnersProps}
 */
const Partners = ({ slice: { items } }) => {
  const continents = [
    "Europe",
    "North America",
    "Asia",
    "Africa",
    "South America",
    "Australia",
  ];

  const [activeContinent, setActiveContinent] = useState(continents[0]);
  const [countries, setCountries] = useState([]);
  const [activeCountry, setActiveCountry] = useState();

  // Create list of countries based on active continent
  const countryList = items.reduce((acc, item) => {
    if (
      item?.partner_continent === activeContinent &&
      !acc.includes(item?.partner_country)
    ) {
      acc.push(item?.partner_country);
    }
    return acc;
  }, []);

  useEffect(() => {
    setCountries(countryList); // Set countries when active continent changes
  }, [activeContinent, items]);

  useEffect(() => {
    setActiveCountry(null); // Reset active country when active continent changes
  }, [activeContinent]);

  useEffect(() => {
    if (!activeCountry) {
      setActiveCountry(countryList[0]); // Set active country to first country in list if not set
    }
  }, [countryList, activeCountry]);

  return (
    <section className={Styles.wrapper}>
      <div className={Styles.mapWrapper}>
        <div className={Styles.mapContainer} data-contain="true">
          <div className={Styles.btnContainer}>
            {continents.map((continent, index) => (
              <Button
                label={continent}
                type="button"
                onClick={() => {
                  setActiveContinent(continent);
                  setCountries([]);
                }}
                key={index}
                variant={
                  activeContinent === continent ? "primary" : "secondary"
                }
              />
            ))}
          </div>
          <InternationalMap
            active={activeContinent}
            setActiveContinent={setActiveContinent}
          />
        </div>
      </div>
      <div className={Styles.partnerWrapper}>
        <div className={Styles.partnerContainer} data-contain="true">
          <div className={Styles.countryList}>
            {countries.map((country, index) => (
              <button
                className={Styles.countryBtn}
                onClick={() => setActiveCountry(country)}
                key={index}
                data-active={activeCountry === country}
              >
                {country}
              </button>
            ))}
          </div>
          <div className={Styles.partnerInfoContainer}>
            {items.map((item, index) => {
              if (
                item?.partner_continent === activeContinent &&
                item?.partner_country === activeCountry
              ) {
                return (
                  <div className={Styles.partnerInfo} key={index}>
                    <h4 className={Styles.partnerTitle}>
                      {item?.partner_title}
                    </h4>
                    <span className={Styles.partnerDescription}>
                      <PrismicRichText field={item?.partner_info} />
                    </span>
                  </div>
                );
              }
              return null; // Return null if the item doesn't match the active continent and country
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
